import React from 'react'

const CredentialDownload = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <path
        fill="#00033A"
        d="M32.415 4.103A3.375 3.375 0 0029.039.727H12.927A3.376 3.376 0 009.55 4.103l-.096 36.15a3.377 3.377 0 003.376 3.376H26v-1.365l-13.19-.01a2.048 2.048 0 01-2.048-2.048l.123-36.119c0-1.13.918-2.047 2.05-2.046l1.864.001c.394 0 .54 0 .564.5.023.519.38.837.862.988.082.026 2.43.04 4.78.042h1c1.974-.001 3.71-.012 3.78-.034.483-.151.84-.468.866-.987.024-.5.169-.5.563-.5l1.848.002c1.13 0 2.047.918 2.046 2.05L31.009 33h1.329l.077-28.897z"
      ></path>
      <path
        fill="#00033A"
        fillRule="evenodd"
        d="M25.3 13.025L24.274 12l-3.338 3.33L17.598 12l-1.025 1.025 4.363 4.364 4.364-4.364z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeWidth="1.6"
        d="M25.665 29.975h-9.468a1.988 1.988 0 010-3.975h9.468a1.987 1.987 0 010 3.975z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        d="M19.06 27.987a.773.773 0 01-1.545 0 .773.773 0 011.544 0zm2.55 0a.772.772 0 11-1.543 0 .772.772 0 011.543 0zm2.551 0a.773.773 0 11-1.547-.002.773.773 0 011.547.002z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeWidth="1.6"
        d="M31.69 46.382a6.69 6.69 0 100-13.382 6.69 6.69 0 000 13.382z"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M28.782 39.98l1.877 1.893 3.941-3.637"
      ></path>
    </svg>
  )
}

export default CredentialDownload